import { render, staticRenderFns } from "./advHistoryData.vue?vue&type=template&id=1dc8aa8e&scoped=true"
import script from "./advHistoryData.vue?vue&type=script&lang=js"
export * from "./advHistoryData.vue?vue&type=script&lang=js"
import style0 from "./advHistoryData.vue?vue&type=style&index=0&id=1dc8aa8e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dc8aa8e",
  null
  
)

export default component.exports